import React, { useRef } from "react";
import { Button, useTheme } from "@mui/material";
import { XMarkIcon } from '@heroicons/react/20/solid';
import useFocusTrap from "../../hooks/useFocusTrap";

const NoActiveTemplateModal = ({
  isOpen,
  onClose,
  onAddTemplate,
}) => {
  const theme = useTheme();
  const modalRef = useFocusTrap(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-start justify-center z-50 bg-black bg-opacity-70"
      onClick={onClose}
    >
      <div className="rounded-lg w-full max-w-md overflow-hidden relative flex flex-col justify-between max-sm:mx-2 mt-[70px]">
        <div
          ref={modalRef}
          className="modal-content relative w-full bg-white rounded-lg shadow-xl flex flex-col overflow-hidden"
          role="dialog"
          aria-modal="true"
          aria-labelledby="no-template-title"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Modal Header */}
          <div
            className="flex justify-between items-center py-4 px-5 border-b"
            style={{
              backgroundColor: theme.palette.primary.main,
              borderColor: theme.palette.secondary.v4,
            }}
          >
            <h2 id="no-template-title" className="font-semibold text-lg">
              No Active Template
            </h2>
            <button
              onClick={onClose}
              aria-label="Close modal"
              className="inline-flex items-center justify-center rounded-full bg-black text-white h-6 w-6 hover:bg-gray-800 transition-colors"
            >
              <XMarkIcon className="h-4 w-4" />
            </button>
          </div>

          {/* Modal Content */}
          <div className="flex flex-col px-5 sm:px-6 py-6 gap-5">
            <div className="flex items-start gap-3">
              <svg
                className="w-6 h-6 flex-shrink-0 mt-0.5"
                style={{ color: "#F59E0B" }}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
              <div className="flex-1">
                <p className="text-base font-medium mb-2" style={{ color: theme.palette.text.main }}>
                  No Active Template Found
                </p>
                <p className="text-sm" style={{ color: theme.palette.text.secondary }}>
                  There is no active standardized resume template. Please create a template to continue.
                </p>
              </div>
            </div>
          </div>

          {/* Modal Footer */}
          <div
            className="flex justify-end gap-3 px-5 py-4 border-t"
            style={{ borderColor: theme.palette.secondary.v4 }}
          >
            <Button
              onClick={onAddTemplate}
              sx={{
                backgroundColor: theme.palette.info.main,
                color: theme.palette.text.light,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: theme.palette.info.dark,
                },
              }}
            >
              Add Template
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoActiveTemplateModal;

